import {Pipe, PipeTransform, Inject} from '@angular/core';
import {BringozVolumePipe} from './bringoz-volume.pipe';

@Pipe({
  standalone: false,
  name: 'servicePackageVolume'
})
export class ServicePackageVolumePipe implements PipeTransform {

  constructor(
    @Inject('splitService') private splitService,
    @Inject(BringozVolumePipe) private bringozVolumePipe: BringozVolumePipe
  ) {
  }

  transform(packages: any[], enableUnitDisplay: boolean): string {
    if (!packages) {
      return '---';
    }
    const countAsTotal = this.splitService.getPackageVolumeIsTotal();

    const itemsVolumeSum = packages.reduce((sum, i) => {
      let itemVolume: number;
      if (i.dimensions?.cube !== undefined) {
        itemVolume = i.dimensions.cube;
      } else {
        itemVolume = i.volume;
      }
      return countAsTotal
        ? sum + itemVolume
        : sum + itemVolume * (i.count || 0);
    }, 0);

    return itemsVolumeSum
      ? this.bringozVolumePipe.transform(itemsVolumeSum, enableUnitDisplay)
      : '--';
  }
}
